(function () {
  "use strict";

  /* ============================================================
     PRESENCE COUNT
  ============================================================ */

  (function initPresence() {
    const root = document.querySelector("[data-hrc-pv]");
    const valEl = root?.querySelector("[data-hrc-pv-n]");
    if (!root || !valEl) return;

    const lo = Math.max(1, parseInt(root.getAttribute("data-hrc-pv-lo") || "14", 10));
    const hi = Math.max(lo, parseInt(root.getAttribute("data-hrc-pv-hi") || "48", 10));
    let current = parseInt(valEl.textContent || String(lo), 10);
    if (!Number.isFinite(current)) current = lo;
    current = Math.min(hi, Math.max(lo, current));
    valEl.textContent = String(current);

    let busy = false;
    let seed = (Date.now() ^ (current * 2654435761)) >>> 0;

    const rand = () => {
      seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
      return seed / 4294967296;
    };

    const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

    const transitionEnd = (el) =>
      new Promise((resolve) => {
        const done = (e) => {
          if (e.target !== el || e.propertyName !== "transform") return;
          el.removeEventListener("transitionend", done);
          resolve();
        };
        el.addEventListener("transitionend", done);
        window.setTimeout(resolve, 500);
      });

    const setCount = async (next) => {
      if (busy || next === current) return;
      busy = true;

      const slot = valEl.parentElement;
      if (slot) slot.style.minWidth = `${String(next).length + 0.25}ch`;

      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduceMotion) {
        current = next;
        valEl.textContent = String(next);
        busy = false;
        return;
      }

      const rising = next > current;
      valEl.classList.remove(
        "is-exit-up",
        "is-exit-down",
        "is-enter-up",
        "is-enter-down",
      );
      void valEl.offsetWidth;
      valEl.classList.add(rising ? "is-exit-up" : "is-exit-down");
      await transitionEnd(valEl);

      current = next;
      valEl.textContent = String(next);
      valEl.classList.remove("is-exit-up", "is-exit-down");
      valEl.classList.add(rising ? "is-enter-up" : "is-enter-down");
      void valEl.offsetWidth;
      valEl.classList.remove("is-enter-up", "is-enter-down");
      await transitionEnd(valEl);
      busy = false;
    };

    const schedule = async () => {
      const mid = (lo + hi) / 2;
      const spread = Math.max(8, hi - lo);

      while (document.contains(root)) {
        await wait(2200 + Math.floor(rand() * 2800));
        if (busy) continue;

        const magRoll = rand();
        let mag;
        if (magRoll < 0.28) mag = 1;
        else if (magRoll < 0.52) mag = 2;
        else if (magRoll < 0.78) mag = 3;
        else if (magRoll < 0.92) mag = 4;
        else mag = 5;

        let upChance = 0.5;
        if (current > mid + spread * 0.18) upChance = 0.32;
        else if (current < mid - spread * 0.18) upChance = 0.68;

        const delta = rand() < upChance ? mag : -mag;
        const next = Math.min(hi, Math.max(lo, current + delta));
        if (next !== current) await setCount(next);
      }
    };

    schedule();
  })();

  /* ============================================================
     GALLERY
  ============================================================ */

  const gallery = document.getElementById("hrc-gallery");
  if (!gallery) return;

  const mediaItems = gallery.querySelectorAll("[data-media-index]");
  const thumbBtns = gallery.querySelectorAll("[data-thumb-index]");
  const swipeDots = gallery.querySelectorAll("[data-dot-index]");

  let activeIndex = 0;

  function goToMedia(idx) {
    if (idx < 0) idx = mediaItems.length - 1;
    if (idx >= mediaItems.length) idx = 0;

    mediaItems.forEach((el) => el.classList.remove("is-active"));
    thumbBtns.forEach((el) => {
      el.classList.remove("is-active");
      el.setAttribute("aria-pressed", "false");
    });
    swipeDots.forEach((el) => el.classList.remove("is-active"));

    mediaItems[idx]?.classList.add("is-active");
    thumbBtns[idx]?.classList.add("is-active");
    thumbBtns[idx]?.setAttribute("aria-pressed", "true");
    swipeDots[idx]?.classList.add("is-active");

    thumbBtns[idx]?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    activeIndex = idx;
  }

  thumbBtns.forEach((btn) => {
    btn.addEventListener("click", () =>
      goToMedia(Number(btn.dataset.thumbIndex)),
    );
  });

  /* Mobile swipe */
  const mainMedia = document.getElementById("hrc-main-media");
  if (mainMedia) {
    let touchStartX = 0;
    let touchStartY = 0;

    mainMedia.addEventListener(
      "touchstart",
      (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      },
      { passive: true },
    );

    mainMedia.addEventListener(
      "touchend",
      (e) => {
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          dx < 0 ? goToMedia(activeIndex + 1) : goToMedia(activeIndex - 1);
        }
      },
      { passive: true },
    );
  }

  /* ============================================================
     LIGHTBOX
  ============================================================ */

  const lightbox = document.getElementById("hrc-lightbox");
  const lightboxWrap = document.getElementById("hrc-lightbox-wrap");
  const lightboxCount = document.getElementById("hrc-lightbox-counter");

  // #MainContent kendi stacking context'ini oluşturduğu için
  // lightbox'ı body altına taşıyıp header'ın üstünde render ediyoruz.
  if (lightbox && lightbox.parentElement !== document.body) {
    document.body.appendChild(lightbox);
  }

  const imageMediaItems = Array.from(mediaItems).filter(
    (m) => m.dataset.mediaType === "image",
  );
  let lightboxIndex = 0;
  let lightboxBuilt = false;

  function updateLightboxCounter() {
    if (lightboxCount) {
      lightboxCount.textContent = `${lightboxIndex + 1} / ${imageMediaItems.length}`;
    }
  }

  function buildLightboxSlides() {
    if (!lightboxWrap || lightboxBuilt) return;
    lightboxWrap.innerHTML = imageMediaItems
      .map((item) => {
        const img = item.querySelector("img");
        const highSrc = img?.dataset.src || img?.src || "";
        return `<div class="hrc-lightbox__slide"><img src="${highSrc}" alt="${img?.alt || ""}" draggable="false"></div>`;
      })
      .join("");
    lightboxBuilt = true;
  }

  function scrollLightboxTo(idx, instant) {
    const slide = lightboxWrap?.children[idx];
    if (!lightboxWrap || !slide) return;
    if (instant) {
      lightboxWrap.scrollLeft = slide.offsetLeft;
      return;
    }
    lightboxWrap.scrollTo({
      left: slide.offsetLeft,
      behavior: "smooth",
    });
  }

  function goLightbox(idx, instant) {
    const total = imageMediaItems.length;
    if (!total) return;
    const next = ((idx % total) + total) % total;
    const isAdjacent = next === lightboxIndex + 1 || next === lightboxIndex - 1;
    const isWrap =
      (lightboxIndex === 0 && next === total - 1) ||
      (lightboxIndex === total - 1 && next === 0);
    lightboxIndex = next;
    updateLightboxCounter();
    scrollLightboxTo(lightboxIndex, instant || isWrap || !isAdjacent);
  }

  function openLightbox(startIdx) {
    buildLightboxSlides();
    lightboxIndex = startIdx;
    updateLightboxCounter();
    scrollLightboxTo(lightboxIndex, true);
    lightbox?.classList.add("is-open");
    lightbox?.setAttribute("aria-hidden", "false");
    document.body.classList.add("hrc-lightbox-open");
    document.body.style.overflow = "hidden";
    requestAnimationFrame(() => scrollLightboxTo(lightboxIndex, true));
  }

  function closeLightbox() {
    lightbox?.classList.remove("is-open");
    lightbox?.setAttribute("aria-hidden", "true");
    document.body.classList.remove("hrc-lightbox-open");
    document.body.style.overflow = "";
  }

  gallery.querySelectorAll("[data-lightbox-open]").forEach((btn) => {
    btn.addEventListener("click", () =>
      openLightbox(Number(btn.dataset.lightboxOpen)),
    );
  });

  lightbox?.querySelectorAll("[data-lightbox-close]").forEach((el) => {
    el.addEventListener("click", closeLightbox);
  });

  lightbox?.querySelector("[data-lightbox-prev]")?.addEventListener("click", () => {
    goLightbox(lightboxIndex - 1);
  });

  lightbox?.querySelector("[data-lightbox-next]")?.addEventListener("click", () => {
    goLightbox(lightboxIndex + 1);
  });

  lightboxWrap?.addEventListener(
    "scroll",
    () => {
      const width = lightboxWrap.clientWidth;
      if (!width || !imageMediaItems.length) return;
      const idx = Math.round(lightboxWrap.scrollLeft / width);
      if (idx < 0 || idx >= imageMediaItems.length || idx === lightboxIndex) return;
      lightboxIndex = idx;
      updateLightboxCounter();
    },
    { passive: true },
  );

  document.addEventListener("keydown", (e) => {
    if (!lightbox?.classList.contains("is-open")) return;
    if (e.key === "Escape") closeLightbox();
    if (e.key === "ArrowLeft") goLightbox(lightboxIndex - 1);
    if (e.key === "ArrowRight") goLightbox(lightboxIndex + 1);
  });

  /* ============================================================
     INFO ACCORDION
  ============================================================ */

  (function initPdpInfoAccordion() {
    const root = document.getElementById("hrc-pdp-info");
    if (!root) return;

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const DURATION_MS = 460;
    const controllers = [];

    const measureHeight = (clip) => clip.getBoundingClientRect().height;

    const makeController = (item, clip) => {
      const ctrl = {
        item,
        clip,
        animating: false,
        fallbackTimer: 0,
        onEnd: null,
        cancel() {
          if (ctrl.onEnd) {
            clip.removeEventListener("transitionend", ctrl.onEnd);
            ctrl.onEnd = null;
          }
          if (ctrl.fallbackTimer) {
            window.clearTimeout(ctrl.fallbackTimer);
            ctrl.fallbackTimer = 0;
          }
        },
        afterHeight(fn) {
          ctrl.cancel();
          const done = (event) => {
            if (event?.propertyName && event.propertyName !== "height") return;
            clip.removeEventListener("transitionend", done);
            ctrl.onEnd = null;
            if (ctrl.fallbackTimer) {
              window.clearTimeout(ctrl.fallbackTimer);
              ctrl.fallbackTimer = 0;
            }
            fn();
          };
          ctrl.onEnd = done;
          clip.addEventListener("transitionend", done);
          ctrl.fallbackTimer = window.setTimeout(done, DURATION_MS);
        },
      };
      return ctrl;
    };

    const closeItem = (ctrl, { instant = false } = {}) => {
      const { item, clip } = ctrl;
      if (!item.open && !ctrl.animating) return;

      ctrl.cancel();

      if (reduceMotion || instant) {
        item.open = false;
        clip.style.height = "";
        ctrl.animating = false;
        return;
      }

      const from = measureHeight(clip);
      ctrl.animating = true;
      clip.style.height = `${from}px`;
      clip.offsetHeight;
      clip.style.height = "0px";
      ctrl.afterHeight(() => {
        item.open = false;
        clip.style.height = "";
        ctrl.animating = false;
      });
    };

    const openItem = (ctrl) => {
      const { item, clip } = ctrl;
      if (item.open && !ctrl.animating) return;

      ctrl.cancel();

      if (reduceMotion) {
        item.open = true;
        clip.style.height = "";
        ctrl.animating = false;
        return;
      }

      ctrl.animating = true;
      item.open = true;
      clip.style.height = "0px";
      clip.offsetHeight;
      clip.style.height = `${clip.scrollHeight}px`;
      ctrl.afterHeight(() => {
        clip.style.height = "auto";
        ctrl.animating = false;
      });
    };

    const closeOthers = (except) => {
      controllers.forEach((ctrl) => {
        if (ctrl !== except) closeItem(ctrl);
      });
    };

    root.querySelectorAll(".hrc-pdp-info__item").forEach((item) => {
      const summary = item.querySelector("summary");
      const clip = item.querySelector(".hrc-pdp-info__clip");
      if (!summary || !clip) return;

      item.removeAttribute("name");
      const ctrl = makeController(item, clip);
      controllers.push(ctrl);

      summary.addEventListener("click", (event) => {
        event.preventDefault();
        if (ctrl.animating) return;

        if (item.open) {
          closeItem(ctrl);
          return;
        }

        closeOthers(ctrl);
        openItem(ctrl);
      });
    });

    root.addEventListener(
      "toggle",
      (event) => {
        const target = event.target;
        if (!target?.classList?.contains("hrc-pdp-info__item") || !target.open) return;
        const opened = controllers.find((ctrl) => ctrl.item === target);
        if (opened) closeOthers(opened);
      },
      true,
    );
  })();

  /* ============================================================
     QUANTITY + INVENTORY CAP
  ============================================================ */

  const FALLBACK_QTY_MAX = 99;
  const i18n = window.hrcI18n || {};
  const t = (key, fallback) => i18n[key] || fallback;
  const tCount = (key, count, fallbackTpl) =>
    (i18n[key] || fallbackTpl)
      .replace("__COUNT__", String(count))
      .replace("{{ count }}", String(count));
  const tPercent = (key, percent, fallbackTpl) =>
    (i18n[key] || fallbackTpl)
      .replace("__PERCENT__", String(percent))
      .replace("{{ percent }}", String(percent));
  const LABEL_COMING_SOON = t("comingSoon", "Coming Soon");
  const LABEL_UNAVAILABLE = t("unavailable", "Unavailable");
  const LABEL_OUT_OF_STOCK = t("outOfStock", "Out of Stock");
  const LABEL_IN_STOCK = t("inStock", "In Stock");
  const LABEL_SOLD_OUT = t("soldOut", "Sold Out");
  const LABEL_ADD_TO_CART = t("addToCart", "Add to Cart");
  const isGiftOnlyPdp =
    document.querySelector(".hrc-pdp")?.getAttribute("data-gift-only") === "true";
  const qtyInput = document.querySelector(".hrc-pdp__qty-input");
  const stockEl = document.querySelector('[id^="hrc-stock-"]');
  const variantInput = document.querySelector('[id^="hrc-variant-input-"]');
  const atcBtn = document.querySelector('[id^="hrc-atc-"]');
  const qtyWrap = document.querySelector(".hrc-pdp__qty-wrap");
  const qtyBtns = qtyWrap
    ? Array.from(qtyWrap.querySelectorAll("[data-qty]"))
    : [];
  const variantsRoot = document.querySelector(".hrc-pdp__variants");
  const sectionId = variantsRoot?.dataset?.section || "";
  const variantsJsonEl = sectionId
    ? document.getElementById(`ProductsJson-${sectionId}`)
    : document.querySelector('[id^="ProductsJson-"]');

  let variants = [];
  try {
    variants = JSON.parse(variantsJsonEl?.textContent || "[]");
    if (!Array.isArray(variants)) variants = [];
  } catch (_) {
    variants = [];
  }

  const cartQtyByVariant = new Map();

  const getRoutesRoot = () => {
    const root = window.Shopify?.routes?.root || "/";
    return root.endsWith("/") ? root : `${root}/`;
  };

  const refreshCartQtyMap = async () => {
    try {
      const res = await fetch(`${getRoutesRoot()}cart.js`, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!res.ok) return;
      const cart = await res.json();
      cartQtyByVariant.clear();
      (cart?.items || []).forEach((item) => {
        const id = Number(item.variant_id || item.id);
        if (!Number.isFinite(id)) return;
        cartQtyByVariant.set(
          id,
          (cartQtyByVariant.get(id) || 0) + Number(item.quantity || 0),
        );
      });
    } catch (_) {
      /* ignore */
    }
  };

  const matchVariantFromOptions = () => {
    if (!variants.length) return null;

    const idFromInput = Number(variantInput?.value || 0);
    const byId = () =>
      Number.isFinite(idFromInput) && idFromInput > 0
        ? variants.find((v) => Number(v.id) === idFromInput) || null
        : null;

    const fieldsets = variantsRoot
      ? Array.from(variantsRoot.querySelectorAll(".hrc-pdp__option-group"))
      : [];

    // Her opsiyon grubundan seçili değeri al (eksik seçim varsa ID'ye düş)
    const values = fieldsets.map((fs) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });

    const allSelected =
      values.length > 0 && values.every((v) => v != null && v !== "");

    if (!allSelected) return byId();

    const matched =
      variants.find((v) => {
        const opts = [v.option1, v.option2, v.option3];
        return values.every((val, i) => String(opts[i] ?? "") === String(val));
      }) || null;

    return matched || byId();
  };

  const readInventoryQty = (variant) => {
    if (variant && Number.isFinite(Number(variant.inventory_quantity))) {
      return Number(variant.inventory_quantity);
    }
    // DOM fallback yalnızca seçili varyant için (başka varyanta bulaştırma)
    if (
      variant &&
      stockEl &&
      variantInput &&
      Number(variantInput.value) === Number(variant.id)
    ) {
      const fromDom = parseInt(stockEl.dataset.inventory || "", 10);
      return Number.isFinite(fromDom) ? fromDom : NaN;
    }
    return NaN;
  };

  /** Stok / policy üzerinden satılabilir mi? */
  const isVariantSellable = (variant) => {
    if (!variant) return false;

    const tracked =
      variant.inventory_management != null &&
      variant.inventory_management !== "";
    if (!tracked) return true;
    if (variant.inventory_policy === "continue") return true;

    if (variant.available === true) return true;

    const inv = readInventoryQty(variant);
    if (Number.isFinite(inv) && inv > 0) return true;

    if (variant.available === false) return false;
    return true;
  };

  const isComingSoonVariant = (variant) => {
    if (!variant) return false;
    const n = Number(variant.price);
    return !Number.isFinite(n) || n <= 0;
  };

  const getInventoryCap = (variant) => {
    if (!variant) return 0;
    if (isComingSoonVariant(variant)) return 0;
    if (!isVariantSellable(variant)) return 0;

    const tracked =
      stockEl?.dataset.tracked === "true" ||
      (variant.inventory_management != null &&
        variant.inventory_management !== "");
    const policy =
      variant.inventory_policy || stockEl?.dataset.policy || "deny";
    const inv = readInventoryQty(variant);

    if (tracked && policy === "deny" && Number.isFinite(inv) && inv > 0) {
      return Math.floor(inv);
    }

    return FALLBACK_QTY_MAX;
  };

  const priceEl = document.querySelector('[id^="hrc-price-"]:not([id*="block"])');
  const priceBlockEl = document.querySelector('[id^="hrc-price-block-"]');
  const compareEl = document.querySelector('[id^="hrc-compare-"]');
  const saveEl = document.querySelector('[id^="hrc-save-"]');
  const saleBadgeEl = document.querySelector('[id^="hrc-sale-badge-"]');
  const stickyPriceEl = document.getElementById("hrc-sticky-price");

  const toCents = (value) => {
    const n = Number(value);
    return Number.isFinite(n) && n > 0 ? Math.round(n) : 0;
  };

  const formatMoney = (cents) => {
    if (window.HrcFormatMoney) {
      return window.HrcFormatMoney(cents, { forceDecimals: true });
    }
    if (window.HrcWebDiscount?.formatCents) {
      return window.HrcWebDiscount.formatCents(cents, { forceDecimals: true });
    }
    const abs = Math.round(Math.abs(Number.isFinite(Number(cents)) ? Number(cents) : 0));
    const grouped = String(Math.floor(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${grouped},${String(abs % 100).padStart(2, "0")}TL`;
  };

  const resolveSalePricing = (variant) => {
    const price = toCents(variant?.price);
    const compare = toCents(variant?.compare_at_price);
    if (window.HrcWebDiscount?.resolveDisplayPricing) {
      const resolved = window.HrcWebDiscount.resolveDisplayPricing(price, compare);
      return {
        price: resolved.price,
        compare: resolved.compare,
        webDiscount: resolved.webDiscount,
        b2bDiscount: resolved.b2bDiscount,
        percent: resolved.percent,
        label: resolved.label,
      };
    }
    return { price, compare: compare > price ? compare : 0, webDiscount: false };
  };

  const syncStockUI = (variant) => {
    if (!stockEl || !variant) return;

    const lowThreshold = parseInt(stockEl.dataset.lowThreshold || "5", 10) || 5;
    const policy = variant.inventory_policy || stockEl.dataset.policy || "deny";
    const tracked =
      variant.inventory_management != null &&
      variant.inventory_management !== "";
    const inv = readInventoryQty(variant);
    const comingSoon = isComingSoonVariant(variant);
    const sellable = !comingSoon && isVariantSellable(variant);

    let state = "out";
    let label = LABEL_SOLD_OUT;

    if (comingSoon) {
      state = "coming-soon";
      label = LABEL_COMING_SOON;
    } else if (sellable) {
      if (
        tracked &&
        policy === "deny" &&
        Number.isFinite(inv) &&
        inv > 0 &&
        inv <= lowThreshold
      ) {
        state = "low";
        label = tCount("lowStock", inv, "Only __COUNT__ left");
      } else {
        state = "in";
        label = LABEL_IN_STOCK;
      }
    }

    stockEl.classList.toggle("is-coming-soon", comingSoon);
    stockEl.innerHTML = `
      <span class="hrc-pdp__stock-dot is-${state}"></span>
      <span class="hrc-pdp__stock-label is-${state}">${label}</span>
    `;
  };

  const notifyPricingApps = (variant) => {
    if (variantInput && variant?.id) {
      variantInput.dispatchEvent(new Event("input", { bubbles: true }));
      variantInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (priceBlockEl && variant?.id) {
      priceBlockEl.setAttribute("data-variant-id", String(variant.id));
    }
    if (priceEl && variant?.id) {
      priceEl.setAttribute("data-variant-id", String(variant.id));
    }
    window.HrcB2B?.notifyPricingApps?.(
      document.querySelector(".hrc-pdp") || document,
      { variant, variantId: variant?.id, id: variant?.id },
    );
  };

  const applyPriceUI = (variant) => {
    if (!variant) return;
    const comingSoon = isComingSoonVariant(variant);

    const { price, compare, webDiscount, b2bDiscount, percent } = resolveSalePricing(variant);
    const onSale = !comingSoon && compare > price && price > 0;

    if (window.HrcB2B?.skipThemePricePaint?.() && !comingSoon) {
      const catalogCents = toCents(variant.price);
      document.querySelectorAll("[data-hrc-clay-price]").forEach((root) => {
        if (window.HrcClaySync?.applyCatalog) {
          window.HrcClaySync.applyCatalog(
            root,
            catalogCents,
            variant.id,
            variant.product_id || priceBlockEl?.getAttribute("data-product-id"),
          );
        } else if (catalogCents) {
          root.setAttribute("data-base-price", String(catalogCents));
          if (variant.id) root.setAttribute("data-variant-id", String(variant.id));
        }
      });
      syncStockUI(variant);
      notifyPricingApps(variant);
      return;
    }

    if (priceBlockEl) {
      priceBlockEl.removeAttribute("hidden");
    }

    if (priceEl) {
      priceEl.textContent = comingSoon ? LABEL_COMING_SOON : formatMoney(price);
      priceEl.classList.toggle("is-sale", onSale);
      priceEl.classList.toggle("price-item--sale", onSale);
      priceEl.classList.toggle("is-coming-soon", comingSoon);
    }

    if (stickyPriceEl) {
      stickyPriceEl.textContent = comingSoon
        ? LABEL_COMING_SOON
        : formatMoney(price);
      stickyPriceEl.classList.toggle("is-coming-soon", comingSoon);
    }

    if (compareEl) {
      if (onSale) {
        compareEl.textContent = formatMoney(compare);
        compareEl.removeAttribute("hidden");
      } else {
        compareEl.setAttribute("hidden", "");
        compareEl.textContent = "";
      }
    }

    if (saveEl) {
      if (onSale) {
        const discount =
          (webDiscount || b2bDiscount) && percent
            ? percent
            : Math.round(((compare - price) / compare) * 100);
        saveEl.textContent = tPercent(
          "savePercent",
          discount,
          "-__PERCENT__% Off",
        );
        saveEl.removeAttribute("hidden");
      } else {
        saveEl.setAttribute("hidden", "");
        saveEl.textContent = "";
      }
    }

    if (saleBadgeEl) {
      if (onSale && !webDiscount && !b2bDiscount) {
        const discount = Math.round(((compare - price) / compare) * 100);
        saleBadgeEl.textContent = `-${discount}%`;
        saleBadgeEl.removeAttribute("hidden");
      } else if (!webDiscount && !b2bDiscount) {
        saleBadgeEl.setAttribute("hidden", "");
      }
    }

    const discountWrap = document.querySelector(".hrc-pdp__discount");
    if (discountWrap) {
      discountWrap.hidden = comingSoon;
    }

    const webDiscountLabel = document.querySelector(".hrc-pdp__web-discount-label");
    if (webDiscountLabel) {
      webDiscountLabel.hidden = comingSoon;
    }

    syncStockUI(variant);
    notifyPricingApps(variant);
  };

  const syncOptionLabels = (variant) => {
    if (!variant) return;
    document.querySelectorAll("[data-selected-val]").forEach((el) => {
      const pos = Number(el.getAttribute("data-selected-val"));
      const val = variant[`option${pos}`];
      if (val != null) el.textContent = val;
    });
  };

  const getSelectedOptionValues = () => {
    if (!variantsRoot) return [];
    return Array.from(
      variantsRoot.querySelectorAll(".hrc-pdp__option-group"),
    ).map((fs) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  };

  const isPurchasableVariant = (variant) =>
    isVariantSellable(variant) && !isComingSoonVariant(variant);

  const optionValueMatches = (variant, optionIndex, value, selectedValues) => {
    const opts = [variant.option1, variant.option2, variant.option3];
    if (String(opts[optionIndex] ?? "") !== String(value)) return false;
    return selectedValues.every((sel, i) => {
      if (i === optionIndex) return true;
      if (sel == null || sel === "") return true;
      return String(opts[i] ?? "") === String(sel);
    });
  };

  const isOptionValueAvailable = (optionIndex, value, selectedValues) => {
    if (!variants.length) return true;
    return variants.some(
      (v) =>
        isPurchasableVariant(v) &&
        optionValueMatches(v, optionIndex, value, selectedValues),
    );
  };

  const isOptionValueComingSoon = (optionIndex, value, selectedValues) => {
    if (!variants.length) return false;
    const matches = variants.filter((v) =>
      optionValueMatches(v, optionIndex, value, selectedValues),
    );
    if (!matches.length) return false;
    if (matches.some((v) => isPurchasableVariant(v))) return false;
    return matches.every((v) => isComingSoonVariant(v));
  };

  const getOptionUnavailableTitle = (optionIndex, value, selectedValues) =>
    isOptionValueComingSoon(optionIndex, value, selectedValues)
      ? LABEL_COMING_SOON
      : LABEL_UNAVAILABLE;

  const setInputAvailability = (
    input,
    available,
    unavailableTitle = LABEL_UNAVAILABLE,
    comingSoon = false,
  ) => {
    const label =
      (input.nextElementSibling?.tagName === "LABEL"
        ? input.nextElementSibling
        : null) ||
      (input.id
        ? document.querySelector(
            `label[for="${(window.CSS && CSS.escape) ? CSS.escape(input.id) : input.id}"]`,
          )
        : null);

    input.disabled = !available;
    if (available) {
      input.removeAttribute("data-unavailable");
      input.removeAttribute("data-coming-soon");
      input.removeAttribute("aria-disabled");
      label?.removeAttribute("aria-disabled");
      label?.removeAttribute("title");
      label?.classList.remove("is-coming-soon");
    } else if (comingSoon) {
      input.removeAttribute("data-unavailable");
      input.setAttribute("data-coming-soon", "");
      input.setAttribute("aria-disabled", "true");
      label?.setAttribute("aria-disabled", "true");
      label?.setAttribute("title", unavailableTitle || LABEL_COMING_SOON);
      label?.classList.add("is-coming-soon");
    } else {
      input.setAttribute("data-unavailable", "");
      input.removeAttribute("data-coming-soon");
      input.setAttribute("aria-disabled", "true");
      label?.setAttribute("aria-disabled", "true");
      label?.setAttribute("title", unavailableTitle);
      label?.classList.remove("is-coming-soon");
    }
    label?.classList.toggle("is-unavailable", !available && !comingSoon);
  };

  /** Disable OOS options; auto-move selection off sold-out values. */
  const syncOptionAvailability = () => {
    if (!variantsRoot || !variants.length) return false;

    const fieldsets = Array.from(
      variantsRoot.querySelectorAll(".hrc-pdp__option-group"),
    );
    let selectionChanged = false;

    fieldsets.forEach((fs, optionIndex) => {
      const selectedValues = getSelectedOptionValues();
      const inputs = Array.from(fs.querySelectorAll('input[type="radio"]'));

      inputs.forEach((input) => {
        const available = isOptionValueAvailable(
          optionIndex,
          input.value,
          selectedValues,
        );
        const comingSoon =
          !available &&
          isOptionValueComingSoon(optionIndex, input.value, selectedValues);
        const title = available
          ? LABEL_UNAVAILABLE
          : getOptionUnavailableTitle(
              optionIndex,
              input.value,
              selectedValues,
            );
        setInputAvailability(input, available, title, comingSoon);
      });

      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked && checked.disabled) {
        const firstOk = fs.querySelector('input[type="radio"]:not(:disabled)');
        if (firstOk) {
          checked.checked = false;
          firstOk.checked = true;
          selectionChanged = true;
        }
      }
    });

    // Dependent options (e.g. size after color) need a second pass
    if (selectionChanged) {
      fieldsets.forEach((fs, optionIndex) => {
        const selectedValues = getSelectedOptionValues();
        fs.querySelectorAll('input[type="radio"]').forEach((input) => {
          const available = isOptionValueAvailable(
            optionIndex,
            input.value,
            selectedValues,
          );
          const comingSoon =
            !available &&
            isOptionValueComingSoon(optionIndex, input.value, selectedValues);
          const title = available
            ? LABEL_UNAVAILABLE
            : getOptionUnavailableTitle(
                optionIndex,
                input.value,
                selectedValues,
              );
          setInputAvailability(input, available, title, comingSoon);
        });
      });
    }

    return selectionChanged;
  };

  const syncVariantUrl = (variant) => {
    if (!variant?.id || !variantsRoot || variantsRoot.dataset.updateUrl !== "true") {
      return;
    }
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", String(variant.id));
      window.history.replaceState({}, "", url.toString());
    } catch (_) {
      /* ignore */
    }
  };

  const getMaxAddable = (variant) => {
    const cap = getInventoryCap(variant);
    if (cap >= FALLBACK_QTY_MAX) return FALLBACK_QTY_MAX;
    const variantId = Number(variant?.id || variantInput?.value || 0);
    const inCart = cartQtyByVariant.get(variantId) || 0;
    return Math.max(0, cap - inCart);
  };

  const syncQtyUI = (variant) => {
    if (!qtyInput) return;
    const maxAddable = getMaxAddable(variant);
    const inputMax = Math.max(1, maxAddable || 1);
    qtyInput.max = String(inputMax);

    let val = parseInt(qtyInput.value, 10);
    if (!Number.isFinite(val) || val < 1) val = 1;
    if (maxAddable > 0) val = Math.min(val, maxAddable);
    else val = 1;
    qtyInput.value = String(val);

    const comingSoon = isComingSoonVariant(variant);
    const soldOut = !variant || !isVariantSellable(variant);
    const canPurchase =
      !isGiftOnlyPdp &&
      !!variant &&
      !soldOut &&
      !comingSoon &&
      isPurchasableVariant(variant) &&
      getInventoryCap(variant) > 0;

    qtyBtns.forEach((btn) => {
      const delta = Number(btn.dataset.qty);
      if (comingSoon || isGiftOnlyPdp) {
        btn.disabled = true;
        return;
      }
      if (delta < 0) btn.disabled = val <= 1;
      if (delta > 0) btn.disabled = maxAddable <= 0 || val >= maxAddable;
    });

    if (qtyInput) qtyInput.disabled = comingSoon || isGiftOnlyPdp;

    const qtyWrapEl = qtyInput?.closest(".hrc-pdp__qty-wrap");
    if (qtyWrapEl) {
      if (comingSoon || isGiftOnlyPdp) qtyWrapEl.setAttribute("data-locked", "true");
      else qtyWrapEl.removeAttribute("data-locked");
    }

    let atcLabel = LABEL_ADD_TO_CART;
    if (comingSoon) atcLabel = LABEL_COMING_SOON;
    else if (soldOut || !canPurchase) atcLabel = LABEL_OUT_OF_STOCK;

    if (atcBtn && !atcBtn.classList.contains("is-loading")) {
      atcBtn.disabled = !canPurchase;
      atcBtn.setAttribute("type", canPurchase ? "submit" : "button");
      const labelEl = atcBtn.querySelector(".hrc-pdp__atc-label");
      if (labelEl) labelEl.textContent = atcLabel;
    }

    const stickyBarEl = document.getElementById("hrc-sticky-bar");
    const stickyAtcEl = document.getElementById("hrc-sticky-atc");
    if (stickyBarEl) {
      stickyBarEl.dataset.available = canPurchase ? "true" : "false";
      if (!canPurchase) {
        stickyBarEl.classList.remove("is-visible");
        stickyBarEl.setAttribute("aria-hidden", "true");
      }
    }
    if (stickyAtcEl) {
      stickyAtcEl.disabled = !canPurchase;
      stickyAtcEl.textContent = atcLabel;
    }

    if (typeof window.__hrcSyncStickyBar === "function") {
      window.__hrcSyncStickyBar();
    }
  };

  const applyVariantInventory = (variant) => {
    if (variantInput && variant?.id) {
      variantInput.value = String(variant.id);
      variantInput.dataset.price = String(toCents(variant.price));
    }

    const formEl =
      variantInput?.closest("form") ||
      document.querySelector(".hrc-pdp__form");
    if (formEl) {
      const zero = isComingSoonVariant(variant);
      if (isGiftOnlyPdp) formEl.dataset.giftOnly = "true";
      if (zero) formEl.dataset.comingSoon = "true";
      else {
        formEl.removeAttribute("data-coming-soon");
        delete formEl.dataset.comingSoon;
      }
    }

    if (variantsRoot) {
      const allUnpriced =
        variants.length > 0 && variants.every((v) => isComingSoonVariant(v));
      variantsRoot.classList.toggle("is-coming-soon-locked", allUnpriced);
      if (allUnpriced) variantsRoot.setAttribute("data-coming-soon-locked", "true");
      else variantsRoot.removeAttribute("data-coming-soon-locked");
    }

    if (variant && stockEl) {
      if (typeof variant.inventory_quantity === "number") {
        stockEl.dataset.inventory = String(variant.inventory_quantity);
      }
      if (variant.inventory_policy) {
        stockEl.dataset.policy = variant.inventory_policy;
      }
      stockEl.dataset.tracked =
        variant.inventory_management != null &&
        variant.inventory_management !== ""
          ? "true"
          : "false";
    }

    applyPriceUI(variant);
    syncOptionLabels(variant);
    syncVariantUrl(variant);
    syncQtyUI(variant);
  };

  qtyBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (!qtyInput || btn.disabled) return;
      const variant = matchVariantFromOptions();
      const maxAddable = getMaxAddable(variant);
      const delta = Number(btn.dataset.qty);
      const current = parseInt(qtyInput.value, 10) || 1;
      const next = Math.max(
        1,
        Math.min(maxAddable > 0 ? maxAddable : 1, current + delta),
      );
      qtyInput.value = String(next);
      syncQtyUI(variant);
    });
  });

  qtyInput?.addEventListener("change", () => {
    syncQtyUI(matchVariantFromOptions());
  });
  qtyInput?.addEventListener("input", () => {
    syncQtyUI(matchVariantFromOptions());
  });

  document
    .querySelectorAll('.hrc-pdp__variants input[type="radio"]')
    .forEach((input) => {
      input.addEventListener("change", () => {
        if (input.disabled || input.hasAttribute("data-unavailable")) {
          input.checked = false;
          syncOptionAvailability();
          return;
        }
        syncOptionAvailability();
        applyVariantInventory(matchVariantFromOptions());
      });
    });

  // Hard-block clicks on sold-out swatches (label/input)
  variantsRoot?.addEventListener(
    "click",
    (e) => {
      const label = e.target.closest("label.hrc-pdp__swatch-label");
      const inputFromLabel = label?.htmlFor
        ? document.getElementById(label.htmlFor)
        : null;
      const input =
        e.target.closest('input[type="radio"]') || inputFromLabel;
      if (!input || !variantsRoot.contains(input)) return;
      if (input.disabled || input.hasAttribute("data-unavailable")) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true,
  );

  variantsRoot?.addEventListener(
    "keydown",
    (e) => {
      const input = e.target.closest?.('input[type="radio"]');
      if (!input || !variantsRoot.contains(input)) return;
      if (
        (input.disabled || input.hasAttribute("data-unavailable")) &&
        (e.key === " " || e.key === "Enter")
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true,
  );

  syncOptionAvailability();
  applyVariantInventory(matchVariantFromOptions());
  refreshCartQtyMap().then(() => {
    syncOptionAvailability();
    applyVariantInventory(matchVariantFromOptions());
  });

  window.addEventListener("cart:updated", () => {
    refreshCartQtyMap().then(() => {
      syncQtyUI(matchVariantFromOptions());
    });
  });

  /* ============================================================
     STICKY ATC CARD (right floating)
  ============================================================ */

  const stickyBar = document.getElementById("hrc-sticky-bar");
  const actionArea = document.querySelector(`[id^="hrc-action-area-"]`);
  const stickyATC = document.getElementById("hrc-sticky-atc");
  const mainForm = document.querySelector('[id^="hrc-pdp-form-"]');
  const mediaCol = document.querySelector(".hrc-pdp__media-col");
  const mobileStickyMq = window.matchMedia("(max-width: 768px)");

  if (stickyBar && actionArea) {
    let actionInView = true;
    let mediaInView = true;
    let footerBrandInView = false;

    const footerBrand = document.querySelector(
      ".hrc-footer__big, .hrc-footer__big-text",
    );

    function syncStickyBar() {
      const available = stickyBar.dataset.available !== "false";
      // Mobile: never cover the gallery — hide while media column is on screen
      // Footer HERCULES band: hide when that area is reached
      const shouldShow = available
        ? footerBrandInView
          ? false
          : mobileStickyMq.matches
            ? !actionInView && !mediaInView
            : !actionInView
        : false;

      stickyBar.classList.toggle("is-visible", shouldShow);
      stickyBar.setAttribute("aria-hidden", String(!shouldShow));
    }

    window.__hrcSyncStickyBar = syncStickyBar;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === actionArea) {
            actionInView = entry.isIntersecting;
          } else if (entry.target === mediaCol) {
            mediaInView = entry.isIntersecting;
          }
        });
        syncStickyBar();
      },
      { threshold: 0, rootMargin: "0px" },
    );

    observer.observe(actionArea);
    if (mediaCol) observer.observe(mediaCol);

    if (footerBrand) {
      const footerObserver = new IntersectionObserver(
        ([entry]) => {
          footerBrandInView = entry.isIntersecting;
          syncStickyBar();
        },
        {
          root: null,
          // Biraz erken gizle; HERCULES bandı görünür görünmez kaybolsun
          rootMargin: "0px 0px 80px 0px",
          threshold: 0,
        },
      );
      footerObserver.observe(footerBrand);
    }

    if (typeof mobileStickyMq.addEventListener === "function") {
      mobileStickyMq.addEventListener("change", syncStickyBar);
    } else if (typeof mobileStickyMq.addListener === "function") {
      mobileStickyMq.addListener(syncStickyBar);
    }

    syncStickyBar();
  }

  stickyATC?.addEventListener("click", () => {
    if (stickyATC.disabled) return;

    const form = mainForm || document.querySelector(".hrc-pdp__form");
    const current = matchVariantFromOptions();
    if (!current) return;

    const variants = document.querySelector(".hrc-pdp__variants");
    const action = document.querySelector(`[id^="hrc-action-area-"]`);
    const infoCol = document.querySelector(".hrc-pdp__info-col");
    const purchaseBlock = form || variants || action || infoCol;
    if (!purchaseBlock) return;

    const header =
      document.getElementById("header-floating") ||
      document.querySelector(".navbar-wrap") ||
      document.querySelector("header");
    const headerH = header ? Math.ceil(header.getBoundingClientRect().height) : 72;
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const gap = isMobile ? 32 : 40;
    const viewH = window.innerHeight;

    const focusAnchor = variants || action || purchaseBlock;

    const scrollPurchaseIntoView = () => {
      const blockRect = purchaseBlock.getBoundingClientRect();
      const anchorRect = focusAnchor.getBoundingClientRect();
      const blockTopDoc = blockRect.top + window.scrollY;
      const anchorTopDoc = anchorRect.top + window.scrollY;
      const usableH = viewH - headerH - gap;

      let nextTop;

      if (isMobile) {
        // Mobilde beden + adet bloğunu ekranın üst-orta bandına getir
        nextTop = anchorTopDoc - headerH - gap;
        const blockBottom = blockTopDoc + blockRect.height;
        const projectedBottom = blockBottom - nextTop;
        if (projectedBottom > viewH - 16) {
          // Blok uzunsa en azından seçenek/adet alanı üstte kalsın
          nextTop = anchorTopDoc - headerH - gap;
        }
      } else if (blockRect.height <= usableH) {
        // Masaüstünde tüm form header altında sığsın
        nextTop = blockTopDoc - headerH - gap;
      } else {
        nextTop = anchorTopDoc - headerH - gap;
      }

      window.scrollTo({ top: Math.max(0, nextTop), behavior: "smooth" });
    };

    scrollPurchaseIntoView();

    // Smooth scroll bitince görünürlüğü doğrula, gerekirse ince ayar
    window.setTimeout(() => {
      const r = focusAnchor.getBoundingClientRect();
      const minTop = headerH + gap;
      const maxBottom = viewH - (isMobile ? 20 : 32);
      let tweak = 0;
      if (r.top < minTop) tweak = r.top - minTop;
      else if (r.bottom > maxBottom) tweak = r.bottom - maxBottom;
      if (Math.abs(tweak) > 2) {
        window.scrollBy({ top: tweak, behavior: "smooth" });
      }

      const focusEl =
        purchaseBlock.querySelector(
          '.hrc-pdp__swatch-list input[type="radio"]:not([data-unavailable])',
        ) ||
        purchaseBlock.querySelector(".hrc-pdp__qty-input") ||
        purchaseBlock.querySelector('[name="add"]');
      if (focusEl && typeof focusEl.focus === "function") {
        try {
          focusEl.focus({ preventScroll: true });
        } catch (_) {
          focusEl.focus();
        }
      }
    }, 560);
  });

  /* Block 0 TL adds at the form level (Enter key / forced submit) */
  mainForm?.addEventListener(
    "submit",
    (e) => {
      const variant = matchVariantFromOptions();
      const price = toCents(variant?.price);
      if (!variant || price === 0 || isGiftOnlyPdp || atcBtn?.disabled) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true,
  );

  /* Add-to-cart is handled globally by cart-notification.js */
})();
